import React from "react";
import { useQuery } from "@apollo/react-hooks";
import { gql } from "apollo-boost";

import ErrorPage from "commonComponents/errorPage/ErrorPage";
import PageHeader from "designV2/components/PageHeader";
import { MetricsSkeleton, TableSkeleton } from "designV2/components/Skeleton";
import ShopProductForm from "./ShopProductForm";
import "./productForm.css";

const GET_PRODUCT = gql`
  query getProductByShopAdmin($_id: ID!) {
    getProductByShopAdmin(_id: $_id) {
      _id
      title
      description
      price
      stock
      photoUrl
      shopMenuName
      subMenuId
      promotion {
        percent
        discountFrom
        discountTo
      }
      reqCarTypes {
        _id
        name
      }
      attributes {
        attributeGroup {
          _id
          name
        }
        att {
          _id
          name
        }
      }
    }
  }
`;

const ShopEditProduct = (props) => {
  const { loading, error, data } = useQuery(GET_PRODUCT, {
    variables: { _id: props.match.params.id },
    fetchPolicy: "network-only",
  });

  if (loading) {
    return (
      <div className="page productFormPage">
        <main className="main">
          <PageHeader title="Edit product" />
          <MetricsSkeleton count={2} />
          <TableSkeleton rows={4} columns={2} />
        </main>
      </div>
    );
  }

  if (error) {
    return <ErrorPage />;
  }

  return <ShopProductForm key={data.getProductByShopAdmin._id} product={data.getProductByShopAdmin} />;
};

export default ShopEditProduct;
